import { redirect } from 'react-router-dom';
import { sendPhoneVerificationCode } from '@api';
import { useApplicationStore } from '@data';

export default async function confirmNumberLoader(): Promise<Response | null> {
  const store = useApplicationStore.getState();
  const { patientAccount, verificationChannel, verificationToken } = store;

  if (!patientAccount?.phoneNumber || !verificationChannel) {
    return redirect('/services');
  }

  if (verificationToken) {
    return null;
  }

  try {
    await sendPhoneVerificationCode({
      phone: patientAccount.phoneNumber,
      verificationChannel,
    });
  } catch {
    // @TODO: Handle error
    return null;
  }

  return null;
}
